import { __rest } from "tslib";
import * as React from 'react';
import { ClassNames } from '../../utils/classNames';
import { AutoResizer } from '../autoResizer/autoResizer.component';
/** A div which expands to fit its children when isOpen is true, otherwise it takes up no space - can work horizontally or vertically */

export var Expandable = React.forwardRef(function (_a, forwardedRef) {
  var isOpen = _a.isOpen,
      className = _a.className,
      direction = _a.direction,
      nativeProps = __rest(_a, ["isOpen", "className", "direction"]);

  return React.createElement(AutoResizer, Object.assign({}, nativeProps, {
    ref: forwardedRef,
    tabIndex: isOpen ? undefined : -1,
    "aria-hidden": !isOpen,
    className: ClassNames.concat('arm-expandable', className),
    "data-direction": direction,
    "data-is-open": !!isOpen
  }));
});
Expandable.defaultProps = {
  direction: 'vertical'
};